// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editcover_container__FHrYK {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
}

.editcover_topImage__rd8Op {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #dadada;
  cursor: default;
}

.editcover_cropModal__j-qz5 {
  left: 10% !important;
}

.editcover_imageStyle__xXyYa {
  object-fit: contain;
}

.editcover_imageStyleBorder__Xdd5e {
  border: 1px solid rgba(0, 0, 0, 0.5);
}

.editcover_fullSize__13ajm {
  height: auto;
  aspect-ratio: 3.3;
}

.editcover_smallSize__huGr8 {
  height: auto;
  aspect-ratio: 13;
}

.editcover_absoluteprofileImage__LNmK8 {
  box-sizing: border-box;
  width: auto;
  height: auto;
  position: absolute;
  top: 100%;
  left: 0px;
  border: 1px solid #dbdbdb;
  min-width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.4);
  z-index: 300;
}

.editcover_absoluteprofileImage__LNmK8 > form:nth-child(1) {
  cursor: pointer;
  padding: 6px 18px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 5px;
}

.editcover_absoluteprofileImage__LNmK8 > div:nth-child(2) {
  border-top: 2px solid #dbdbdb;
  padding: 6px 18px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 5px;
}

.editcover_absoluteprofileImage__LNmK8 img {
  background-color: inherit !important;
}

.editcover_absoluteContainer__RAjWG {
  position: absolute;
  right: 4rem;
  bottom: -4rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  z-index: 999;
}

.editcover_absoluteEditContainer__Yry79 {
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
}

.editcover_editImage__wN3\\+n > :nth-child(2) {
  margin-left: 12px;
}

.editcover_absoluteImage__B5aeO {
  box-sizing: border-box;
  width: 113px;
  height: 113px;
  border-radius: 50%;
  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);
  border: 10px solid #ffffff;
}

.editcover_editImage__wN3\\+n {
  box-sizing: border-box;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  align-items: center;
}

.editcover_changeCover__68hY9 {
  width: 122px;
  height: 37px;
  background: #f8f8f8;
  border-radius: 4px;
}

.editcover_absoluteImage__B5aeO img {
  background-color: #dadada;
  border-radius: 50%;
}

.editcover_text__2-f2g {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
}

.editcover_textHead__Dr0lr {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #707070;
}

.editcover_uploadButton__onnx7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  width: 100px;
  height: 37px;
  border-radius: 4px;
  cursor: pointer;
}

.editcover_uploadButtonCover__As5Rc {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 24px;
  width: 122px;
  height: 37px;
  border-radius: 4px;
}

.editcover_uploadButtonUserImage__43sOt {
  width: 35px;
  height: 35px;
  background: #5e5e5e;
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  bottom: -5px;
  cursor: pointer;
}

.editcover_uploadButtonUserImage__43sOt img {
  background-color: inherit !important;
}

.editcover_absoluteResizeCover__B90HU {
  position: absolute;
  width: 24px;
  height: 24px;
  left: 12px;
  top: calc(100% - 10px);
  cursor: pointer;
  background: #e8e8e8;
  border: 1px solid #dbdbdb;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.19);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width: 800px) {
  .editcover_absoluteContainer__RAjWG {
    right: 20px;
  }
}
.editcover_lds_ring__AJk6S {
  width: 20px !important;
  height: 20px !important;
}

@media only screen and (max-width: 800px) {
  .editcover_follower__NpIO- {
    display: none;
  }
  .editcover_topImage__rd8Op {
    border-radius: 0;
  }
  .editcover_cropModal__j-qz5 {
    left: 0% !important;
  }
  .editcover_marginBottom__m-tZb {
    margin-bottom: 10px;
    border-radius: 0 !important;
  }
  .editcover_absoluteContainer__RAjWG {
    position: absolute;
    right: 13px;
    bottom: -32px;
  }
  .editcover_absoluteImage__B5aeO {
    width: 64px;
    height: 64px;
    border: 6px solid #ffffff;
  }
  .editcover_text__2-f2g {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: -2px !important;
    /* identical to box height, or 157% */
    color: #707070;
  }
  .editcover_textHead__Dr0lr {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height, or 138% */
    color: #707070;
  }
  .editcover_topImage__rd8Op {
    border-radius: 0px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .editcover_marginBottom__m-tZb {
    width: 100%;
    height: auto;
    aspect-ratio: 3.3;
  }
  .editcover_imageContainer__Vmv9D {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 68%);
  }
  .editcover_uploadButtonUserImage__43sOt {
    width: 30px;
    height: 30px;
  }
  .editcover_absoluteprofileImage__LNmK8 {
    right: 0;
    top: 120%;
  }
  .editcover_showDesktop__J3wSn {
    display: none;
  }
  .editcover_marginBottom__m-tZb {
    width: 100%;
    height: auto;
    aspect-ratio: 3.3;
    margin-bottom: 30px;
  }
  .editcover_uploadButton__onnx7 {
    width: auto;
    height: auto;
    padding: 4px;
    font-size: 10px;
  }
  .editcover_editImage__wN3\\+n > :nth-child(2) {
    margin-left: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/EditImage/editcover.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AACA;EACE,oBAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AADA;EACE,oCAAA;AAIF;;AAFA;EAEE,YAAA;EACA,iBAAA;AAIF;;AADA;EACE,YAAA;EACA,gBAAA;AAIF;;AADA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAIA,SAAA;EACA,SAAA;EAGA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,2CAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAQA;EACE,6BAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AALF;;AAYA;EACE,oCAAA;AATF;;AAiBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;AAdF;;AAgBA;EACE,iBAAA;AAbF;;AAgBA;EAEE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,4CAAA;EACA,0BAAA;AAdF;;AAkBA;EAEE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;AAhBF;;AAsBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;;AAsBA;EAEE,yBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAvBF;;AA2BA;EACE,oCAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAxBF;;AAiCA;EACE;IACE,WAAA;EA9BF;AACF;AAoFA;EACE,sBAAA;EACA,uBAAA;AAlFF;;AAsFA;EACE;IACE,aAAA;EAnFF;EAsFA;IACE,gBAAA;EApFF;EAsFA;IACE,mBAAA;EApFF;EAsFA;IACE,mBAAA;IAGA,2BAAA;EAtFF;EAyFA;IACE,kBAAA;IACA,WAAA;IACA,aAAA;EAvFF;EA0FA;IACE,WAAA;IACA,YAAA;IACA,yBAAA;EAxFF;EA2FA;IAEE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,8BAAA;IACA,qCAAA;IAEA,cAAA;EA3FF;EA8FA;IASE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,qCAAA;IAEA,cAAA;EArGF;EAwGA;IACE,kBAAA;IACA,oCAAA;EAtGF;EAyGA;IACE,WAAA;IACA,YAAA;IAEA,iBAAA;EAxGF;EA2GA;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,qEAAA;EAzGF;EA6GA;IACE,WAAA;IACA,YAAA;EA3GF;EA8GA;IACE,QAAA;IACA,SAAA;EA5GF;EA+GA;IACE,aAAA;EA7GF;EAgHA;IACE,WAAA;IACA,YAAA;IAEA,iBAAA;IACA,mBAAA;EA/GF;EAiHA;IACE,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EA/GF;EAiHA;IACE,gBAAA;EA/GF;AACF","sourcesContent":[".container {\n  display: inline-flex;\n  align-items: center;\n  font-size: 16px;\n}\n\n.topImage {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  border: 1px solid #e0e0e0;\n  box-sizing: border-box;\n  border-radius: 8px;\n  background-color: #dadada;\n  cursor: default;\n}\n.cropModal {\n  left: 10% !important;\n}\n.imageStyle{\n  object-fit: contain;\n}\n.imageStyleBorder{\n  border:1px solid rgba(0,0,0,0.5);\n}\n.fullSize {\n  // height: 25rem;\n  height: auto;\n  aspect-ratio: 3.3;\n}\n\n.smallSize {\n  height: auto;\n  aspect-ratio: 13;\n}\n\n.absoluteprofileImage {\n  box-sizing: border-box;\n  width: auto;\n  height: auto;\n  position: absolute;\n  // top: 61%;\n  // left: 107px;\n  \n  top:100%;\n  left:0px;\n  // background-color: #f8f8f8;\n  // padding: 2px 8px;\n  border: 1px solid #dbdbdb;\n  min-width: 80px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  box-shadow: 0px 8px 20px rgb(0 0 0 / 40%);\n  z-index: 300;\n}\n\n.absoluteprofileImage > form:nth-child(1) {\n  cursor: pointer;\n  padding: 6px 18px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 5px;\n}\n// .absoluteprofileImage>form:nth-child(1):hover {\n//   color: #fff;\n//   background-color: rgba(27, 27, 27, 0.6);\n//   border-radius:4px;\n// }\n.absoluteprofileImage > div:nth-child(2) {\n  border-top: 2px solid #dbdbdb;\n  padding: 6px 18px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-right: 5px;\n}\n// .absoluteprofileImage>div:nth-child(2):hover {\n//   color: #fff;\n//   background-color: rgba(27, 27, 27, 0.6);\n//   border-radius:4px;\n// }\n.absoluteprofileImage img {\n  background-color: inherit !important;\n}\n\n// .topImage span {\n//   border: 1px solid #e0e0e0;\n//   box-sizing: border-box;\n//   border-radius: 8px;\n// }\n.absoluteContainer {\n  position: absolute;\n  right: 4rem;\n  bottom: -4rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-end;\n  z-index: 999;\n}\n\n.absoluteEditContainer {\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n.editImage > :nth-child(2) {\n  margin-left: 12px;\n}\n\n.absoluteImage {\n  // position: absolute;\n  box-sizing: border-box;\n  width: 113px;\n  height: 113px;\n  border-radius: 50%;\n  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);\n  border: 10px solid #ffffff;\n  // position: relative;\n}\n\n.editImage {\n  // position: absolute;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  align-items: center;\n  // position: relative;\n  // width: 113px;\n  // height: 113px;\n}\n\n.changeCover {\n  width: 122px;\n  height: 37px;\n  background: #f8f8f8;\n  border-radius: 4px;\n}\n\n.absoluteImage img {\n  // background-color: #b1b1b1;\n  background-color: #dadada;\n  border-radius: 50%;\n}\n\n.text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: right;\n}\n\n.textHead {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n\n  color: #707070;\n}\n\n.uploadButton {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  width: 100px;\n  height: 37px;\n  // background: #f8f8f8;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.uploadButtonCover {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 24px;\n  width: 122px;\n  height: 37px;\n  // background: #f8f8f8;\n  border-radius: 4px;\n}\n\n.uploadButtonUserImage {\n  width: 35px;\n  height: 35px;\n  background: #5e5e5e;\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 0px;\n  bottom: -5px;\n  cursor: pointer;\n\n}\n\n.uploadButtonUserImage img {\n  background-color: inherit !important;\n}\n\n.absoluteResizeCover {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  left: 12px;\n  top: calc(100% - 10px);\n  cursor: pointer;\n  background: #e8e8e8;\n  border: 1px solid #dbdbdb;\n  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.19);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n@media only screen and (max-width: 1440px) {\n  .fullSize {\n    // height: 20rem;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .absoluteContainer {\n    right: 20px;\n  }\n\n  .fullSize {\n    // margin-bottom: 4rem;\n  }\n}\n\n//------------------------loader style\n\n// .lds_ring {\n//   // display: inline-block;\n//   // position: absolute;\n//   // width: 100%;\n//   height: 40px;\n//   // top: 20px;\n//   // left: 20px;\n//   // margin-bottom: 10px;\n//   // margin-right: 20px;\n// }\n\n// .lds_ring div {\n//   box-sizing: border-box;\n//   display: block;\n//   position: absolute;\n//   width: 14px;\n//   height: 14px;\n//   // margin: 8px;\n//   border: 1px solid #d8000d;\n//   border-radius: 50%;\n//   animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n//   border-color: #d8000d transparent transparent transparent;\n// }\n\n// .lds_ring div:nth-child(1) {\n//   animation-delay: -0.45s;\n// }\n\n// .lds_ring div:nth-child(2) {\n//   animation-delay: -0.3s;\n// }\n\n// .lds_ring div:nth-child(3) {\n//   animation-delay: -0.15s;\n// }\n\n// @keyframes lds_ring {\n//   0% {\n//     transform: rotate(0deg);\n//   }\n\n//   100% {\n//     transform: rotate(360deg);\n//   }\n// }\n.lds_ring {\n  width:20px !important;\n  height:20px !important;\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .follower {\n    display: none;\n  }\n\n  .topImage {\n    border-radius: 0;\n  }\n  .cropModal {\n    left: 0% !important;\n  }\n  .marginBottom {\n    margin-bottom: 10px;\n    // margin: 0 -10px;\n    // width: calc(100% + 20px) !important;\n    border-radius: 0 !important;\n  }\n\n  .absoluteContainer {\n    position: absolute;\n    right: 13px;\n    bottom: -32px;\n  }\n\n  .absoluteImage {\n    width: 64px;\n    height: 64px;\n    border: 6px solid #ffffff;\n  }\n\n  .text {\n    // max-width: 100px; // margin-bottom: 2px !important;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    margin-bottom: -2px !important;\n    /* identical to box height, or 157% */\n\n    color: #707070;\n  }\n\n  .textHead {\n    // font-style: normal;\n    // font-weight: 500;\n    // font-size: 14px;\n    // line-height: 22px;\n    // /* identical to box height, or 157% */\n\n    // color: #707070;\n\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    /* identical to box height, or 138% */\n\n    color: #707070;\n  }\n\n  .topImage {\n    border-radius: 0px;\n    background-color: rgba(0, 0, 0, 0.6);\n  }\n\n  .marginBottom {\n    width: 100%;\n    height: auto;\n    // aspect-ratio: 2.16;\n    aspect-ratio: 3.3;\n  }\n\n  .imageContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 68%);\n    // linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 67.66%),\n  }\n\n  .uploadButtonUserImage {\n    width: 30px;\n    height: 30px;\n  }\n\n  .absoluteprofileImage {\n    right: 0;\n    top: 120%;\n  }\n\n  .showDesktop {\n    display: none;\n  }\n\n  .marginBottom {\n    width: 100%;\n    height: auto;\n    // aspect-ratio: 2.16;\n    aspect-ratio: 3.3;\n    margin-bottom: 30px;\n  }\n  .uploadButton {\n    width: auto;\n    height: auto;\n    padding: 4px;\n    font-size: 10px;\n  }\n  .editImage > :nth-child(2) {\n    margin-left: 6px;\n  }\n}\n\n@media only screen and (max-width: 370px) {\n  .uploadButton {\n    // width: 80px;\n    // font-size: 14px;\n    // padding: 6px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `editcover_container__FHrYK`,
	"topImage": `editcover_topImage__rd8Op`,
	"cropModal": `editcover_cropModal__j-qz5`,
	"imageStyle": `editcover_imageStyle__xXyYa`,
	"imageStyleBorder": `editcover_imageStyleBorder__Xdd5e`,
	"fullSize": `editcover_fullSize__13ajm`,
	"smallSize": `editcover_smallSize__huGr8`,
	"absoluteprofileImage": `editcover_absoluteprofileImage__LNmK8`,
	"absoluteContainer": `editcover_absoluteContainer__RAjWG`,
	"absoluteEditContainer": `editcover_absoluteEditContainer__Yry79`,
	"editImage": `editcover_editImage__wN3+n`,
	"absoluteImage": `editcover_absoluteImage__B5aeO`,
	"changeCover": `editcover_changeCover__68hY9`,
	"text": `editcover_text__2-f2g`,
	"textHead": `editcover_textHead__Dr0lr`,
	"uploadButton": `editcover_uploadButton__onnx7`,
	"uploadButtonCover": `editcover_uploadButtonCover__As5Rc`,
	"uploadButtonUserImage": `editcover_uploadButtonUserImage__43sOt`,
	"absoluteResizeCover": `editcover_absoluteResizeCover__B90HU`,
	"lds_ring": `editcover_lds_ring__AJk6S`,
	"follower": `editcover_follower__NpIO-`,
	"marginBottom": `editcover_marginBottom__m-tZb`,
	"imageContainer": `editcover_imageContainer__Vmv9D`,
	"showDesktop": `editcover_showDesktop__J3wSn`
};
export default ___CSS_LOADER_EXPORT___;
